import { handleError } from "../util";
import { normalizeError } from "../util/error";
import ErrorPageService from "./errorPageService";
import { ErrorReasonKey, needToLoginErrors, tokenExpiredErrors, } from "../constants/authErrorDetails";
export default class ErrorService extends ErrorPageService {
    show(props) {
        var _a, _b, _c, _d, _e, _f;
        this._props = Object.assign({ hasError: true }, props);
        if (props && props.error) {
            if ("response" in props.error && ((_a = props.error.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
                const normalizedError = normalizeError({ error: props.error });
                this._props = Object.assign(Object.assign({ hasError: true, buttons: ["goBack"] }, props), { error: normalizedError, message: `Не удалось обработать полученные данные.
            Мы подготовили отчет и отправили его разработчикам`, title: "Произошла ошибка" });
                this.notify("show");
                throw props.error;
            }
            else if (String(props.error).includes("timeout")) {
                const normalizedError = normalizeError({ error: props.error });
                this._props = Object.assign(Object.assign({ hasError: true, buttons: ["goBackSecondary", "refresh"] }, props), { error: normalizedError, message: "Вы можете обновить страницу или вернуться в предыдущий раздел", title: "Что-то пошло не так..." });
                this.notify("show");
                throw props.error;
            }
            else if ("response" in props.error &&
                (((_b = props.error.response) === null || _b === void 0 ? void 0 : _b.status) === 401 ||
                    ((_c = props.error.response) === null || _c === void 0 ? void 0 : _c.status) === 403)) {
                const normalizedError = normalizeError({ error: props.error });
                const reason = (_d = props.error.response.data.errors[0]) === null || _d === void 0 ? void 0 : _d[ErrorReasonKey];
                const title = (_e = props.error.response.data.errors[0].presentationData.title) !== null && _e !== void 0 ? _e : " Что-то пошло не так ...";
                const message = (_f = props.error.response.data.errors[0].presentationData.message) !== null && _f !== void 0 ? _f : "Произошла неизвестная ошибка";
                this._props = Object.assign(Object.assign({}, props), { hasError: true, title,
                    message, buttons: needToLoginErrors.includes(reason)
                        ? ["toLoginPage"]
                        : tokenExpiredErrors.includes(reason)
                            ? ["toLoginPage"]
                            : ["goBack"], error: normalizedError });
                this.notify("show");
                throw props.error;
            }
            else {
                handleError({
                    error: props.error,
                    defaultError: "Произошла неизвестная ошибка",
                });
                return;
            }
        }
        this.notify("show");
    }
}
export const errorService = new ErrorService();
//# sourceMappingURL=errorService.js.map